import React from "react";

const ScrollIndicator = () => (
    <div className="text-center animate-bounce absolute bottom-10 w-full">
      <span className="text-white">↓ Scroll Down ↓</span>
    </div>
);

export default ScrollIndicator;
